import React from 'react'
import PropTypes from 'prop-types'
import { ReactSVG } from 'react-svg'
import LoadingSwitchMeter from 'components/patterns/LoadingSwitchMeter'
import BlankPart from './BlankPart'

/**
 * @typedef {Object} Props
 * @property {{ height: string, width: string }} dimensions dimensions
 * @property {string} [imageUrl] svg image url
 * @property {string} location location name
 * @property {React.CSSProperties} style css styles
 */

/**
 * Dynamically load SVG from image url
 * @param {Props} props props
 * @returns {React.FC<Props>}
 */
const DynamicPart = ({ dimensions, imageUrl, location, style }) => {
  return (
    <ReactSVG
      src={imageUrl}
      style={style}
      loading={() => (
        <LoadingSwitchMeter
          width={dimensions.width}
          height={dimensions.height}
        />
      )}
      fallback={() => (
        <BlankPart location={location} style={style} dimensions={dimensions} />
      )}
    />
  )
}

DynamicPart.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  style: PropTypes.object,
  dimensions: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
  }),
}

export default DynamicPart
